import { Heading, Text } from '@chakra-ui/react'
import styled from '@emotion/styled'
import React, { useEffect, useState } from 'react'
import Loader from '../Component/Laoder';

const Cultrul = () => {
    const [flag,setFlag] = useState(true);
  useEffect(()=>{
    setTimeout(() => {
      setFlag(false);
    }, 2000);
  },[])
  if (flag) {
    return <Loader/>
  }
    return (
        <div>
            <Heading alignItems={'self-end'}>Durga Puja</Heading>
            <br />
            <ImgDiv>
                <img src='https://drive.google.com/uc?id=1Vvyz8lgCtOyVqNuVx7TD3T7YM_NOxcBW' alt='durga puja'
                    style={{
                        height: '300px',
                        width: "400px"
                    }}
                />
                <img src='https://drive.google.com/uc?id=1eS5cMkpvqoSyPpNz2YIkJ9O-wOGQ_jd6' alt='durga puja'
                    style={{
                        height: '300px',
                        width: "400px"
                    }}
                />
                <img src='https://drive.google.com/uc?id=10SPQlzGJNpO7o15rQ3TwHFLj8VDk2kPR' alt='durga puja'
                    style={{
                        height: '300px',
                        width: "400px"
                    }}
                />
            </ImgDiv>
            <Text>It won’t be entirely an exaggeration to say that Bengalis world over spend a significant amount of their time planning and deciding what to do during the Durga Pujas. Most of them wear multiple sets of clothes – mind you, there’s a morning outfit and an evening outfit, plus emergency backup outfits. And of course, there are important decisions to make – like what to eat on which day. From the warm khichudi, papad bhaja as bhog in pandals to the street stalls set up to serve delectable dishes like egg rolls, kobiraji and mughlai parota, you are game to feast on anything and everything.

                So prior to the pujas, the air is absolutely thick with a feeling one gets just before the starting, the unravelling of something extremely huge — the feeling you get just before reaching the peak of a much awaited climax.

                You will get to see sweaty Bongs, who under the twelve o’clock sun, sits in an auto patiently stuck in a huge traffic jam in the heart of a buzz-filled street near Dakshinapan or Hatibagan market, clutching onto innumerable bulging shopping bags of different shapes and sizes. This is called Puja shopping.

                By walking down the lanes and by-lanes of the city of Kolkata, and its every nook and corner, particularly during the Pujas, you slowly start feeling the pulse of the city. It is a reverberating rhythm which amplifies and resounds in the sounds of the dhak. It’s a feeling. You can not only hear it, but feel it — you get goose bumps when the dhakis first begin to play their beat. The city reverberates with the echo of conch shells, which is no less than a divine feeling.

                Durga Puja is actually, the celebration of ‘life’ and the joy of ‘living’ more than anything else. It’s like all the joys of this ‘city of joy’ is out on its very streets. Durga Puja becomes an expression of the city itself. It is almost that the city bursts into laughter during these few days.

            </Text>
            <br />
            <Heading>Barajiakur Kirton</Heading>
            <br />
            <ImgDiv>
                <img src='https://drive.google.com/uc?id=1frpnHITKS7OLVRJj_TXe095sGscfEUoS' alt='durga puja'
                    style={{
                        height: '300px',
                        width: "400px"
                    }}
                />
                <img src='https://drive.google.com/uc?id=1bzKe1D74XEjLMN_3r34ZGLdDGlBVaEuZ' alt='durga puja'
                    style={{
                        height: '300px',
                        width: "400px"
                    }}
                />
                <img src='https://drive.google.com/uc?id=1bkrFFwkHG66cfCQ1fXOE4eX9O7fVqFza' alt='durga puja'
                    style={{
                        height: '300px',
                        width: "400px"
                    }}
                />
            </ImgDiv>
            <br />
            <Text>
                {`
      Kirton (কীর্তন) is a vibrant and devotional musical tradition deeply rooted in Bengali culture. It encompasses a diverse range of devotional songs and hymns sung in praise of Hindu deities, particularly during religious gatherings, festivals, and social ceremonies. Kirton is an expression of deep reverence, spiritual connection, and communal celebration. It brings together devotees who engage in group singing, creating an atmosphere of devotion and collective harmony. Accompanied by instruments like the harmonium, tabla, and sometimes cymbals, Kirton creates a mesmerizing melodic tapestry.

    The lyrics of Kirton, often composed in medieval Bengali poetry forms like Padavali and Kirtan, convey profound spiritual and philosophical messages. Through melodious tunes and rhythmic patterns, Kirton evokes a range of emotions, from deep introspection to ecstatic joy. It transcends linguistic barriers, embracing people from all walks of life.

    Kirton not only serves as a means of expressing devotion but also acts as a vehicle for cultural preservation and social bonding. It has played a significant role in sustaining and propagating Bengali traditions and values through generations. Kirton's timeless melodies continue to inspire and uplift hearts, fostering a sense of unity and spirituality within the Bengali community.
      `}
            </Text>

            <br />
            <Heading>Barajiakur Charak</Heading>
            <br />
            <ImgDiv>
                <img src='https://drive.google.com/uc?id=1F8cjAk-v2XIo-hYFJP6IFQifgKnpj90I' alt='durga puja'
                    style={{
                        height: '300px',
                        width: "400px"
                    }}
                />
                <img src='https://drive.google.com/uc?id=14EKmdxHA8WHoEdEpzqq2MdAb-mAWqDlS' alt='durga puja'
                    style={{
                        height: '300px',
                        width: "400px"
                    }}
                />
                <img src='https://drive.google.com/uc?id=1YV44utfy_C8YNH-VhG7JOuyaH7D3wnS5' alt='durga puja'
                    style={{
                        height: '300px',
                        width: "400px"
                    }}
                />
            </ImgDiv>
            <br />
            <Text>
                {`
            Yes, I'm familiar with Charak Mela. Charak Mela is a traditional Bengali festival celebrated primarily in West Bengal, India, and Bangladesh. It is associated with the worship of Lord Shiva and takes place during the Bengali month of Chaitra (March-April) on the day of Charak Puja.

            Charak Mela is characterized by unique rituals and performances. The main attraction of the festival is the Charak Tree, a tall bamboo pole adorned with colorful decorations, flowers, and leaves. A daring individual known as the "Charak" is harnessed to the pole with hooks or nails inserted into his back. He then ascends the pole and rotates in mid-air, symbolizing the victory of life over death and the renewal of nature.

           The festival also involves music, dance, and processions with participants dressed in vibrant attire. Devotees gather to witness the spectacle, offer prayers, and seek blessings from Lord Shiva. The atmosphere is filled with excitement, religious fervor, and a sense of community celebration.

          Charak Mela showcases the cultural heritage and religious traditions of Bengal, reflecting the belief in the cycle of life and the power of devotion. It is a unique and captivating event that attracts locals and visitors alike.
            `}
            </Text>
        </div>
    )
}

export default Cultrul

const ImgDiv = styled.div`
  display: flex;
  margin: auto;
  width: 80%;
  padding: 10px;
  gap: 10px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    width: 100%;

    img {
      width: 100%;
    }
  }
`;